import './styles.scss';

import { IModalBaseProps } from '@components/common/Modal/Modal';
import { Form } from '@components/Form/Form';
import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Modal, Typography } from 'antd';
import { ButtonType } from 'antd/es/button';
import React, { ReactNode } from 'react';

export interface IModalFormProps extends IModalBaseProps {
  mode: 'form';
  title?: string;
  text?: string | ReactNode;
  schema: ModalFormItem[];
  data?: Record<string, any>;
  layout?: {
    formLayout: 'horizontal' | 'vertical';
    itemLayout: 'horizontal' | 'vertical';
    rowGutter?: number;
    colSpan?: number;
  };
  buttons?: {
    submit?: {
      text?: string;
      type?: ButtonType;
    };
    cancel?: {
      text?: string;
      type?: ButtonType;
    };
  };
  columns?: number;
  width?: string | number;
  formRef?: any;
  formKey?: string;
}

export type ModalFormItem = IFormItem;

export const ModalForm: React.FC<IModalFormProps> = ({
  open,
  title,
  text,
  schema,
  data,
  onSubmit,
  onCancel,
  layout,
  buttons,
  width = '695px',
  formKey,
  formRef,
  centered,
  destroyOnHidden,
}: IModalFormProps) => {
  return (
    <Modal
      centered={centered}
      className={'modal'}
      open={open}
      footer={null}
      width={width}
      onCancel={onCancel}
      destroyOnHidden={destroyOnHidden}>
      {text ? (
        typeof text === 'string' ? (
          <Typography.Paragraph className="modal-text">{text}</Typography.Paragraph>
        ) : (
          text
        )
      ) : (
        title && <Typography.Title className={'modal-title'}>{title}</Typography.Title>
      )}
      <Form
        key={formKey}
        ref={formRef}
        schema={schema}
        data={data}
        onSubmit={onSubmit}
        onCancel={onCancel}
        layout={layout}
        buttons={buttons}
      />
    </Modal>
  );
};
